import React, { Component } from 'react'

export class Home extends Component {
  render() {
    return (
      <div>Home</div>
    )
  }
}

export default Home